import script from "./inputBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./inputBox.vue?vue&type=script&setup=true&lang=ts"

import "./inputBox.vue?vue&type=style&index=0&id=5eda226a&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eda226a"]])

export default __exports__